var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewsJobs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37468 8.23419C1.31912 8.08452 1.31912 7.91987 1.37468 7.77019C1.91581 6.4581 2.83435 5.33622 4.01386 4.54679C5.19336 3.75736 6.58071 3.33594 8.00001 3.33594C9.41932 3.33594 10.8067 3.75736 11.9862 4.54679C13.1657 5.33622 14.0842 6.4581 14.6253 7.77019C14.6809 7.91987 14.6809 8.08452 14.6253 8.23419C14.0842 9.54629 13.1657 10.6682 11.9862 11.4576C10.8067 12.247 9.41932 12.6684 8.00001 12.6684C6.58071 12.6684 5.19336 12.247 4.01386 11.4576C2.83435 10.6682 1.91581 9.54629 1.37468 8.23419Z",
    stroke: "#65748B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z",
    stroke: "#65748B",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewsJobs);
export default __webpack_public_path__ + "static/media/views Jobs.50d9c6623e171b95ad31dfe44bfaf8d8.svg";
export { ForwardRef as ReactComponent };